export enum LoyaltyParticipantTypeEnum {
    TwoWheels = 1,
    FourWheels = 2
}
